import { Box, Flex } from '@chakra-ui/react';

const ParticipantPosition = ({ position, isMe, isSimple }: { position: number; isMe: boolean; isSimple?: boolean }) => {
  return (
    <Flex alignItems="flex-end" flex="1">
      <Box
        fontSize={isSimple ? '14px' : position < 4 ? '18px' : '14px'}
        fontWeight="400"
        lineHeight="1"
        fontFamily="Special Gothic Expanded One"
        color={isMe ? '#FFFFFF' : '#F83C3C'}
      >
        {position}
      </Box>
      {/* <Box fontSize="14px" fontWeight="700" lineHeight="14px">
        {getOrdinalSuffix(position)}
      </Box> */}
    </Flex>
  );
};

export default ParticipantPosition;
